export function printIfNeeded (item) {
  if (this.context.isPrint && !this.state.didPrint && item) {
    window.print()
    this.setState({ didPrint: true })
  }
}
